var map = {
	"./en/A1.jpg": 512,
	"./en/A2.jpg": 3503,
	"./en/A3.jpg": 7122,
	"./en/A4.jpg": 8817,
	"./en/A5.jpg": 772,
	"./en/A6.jpg": 819,
	"./en/A7.jpg": 5558,
	"./en/A8.jpg": 5669,
	"./en/B1.jpg": 8777,
	"./en/B2.jpg": 5070,
	"./en/B3.jpg": 9851,
	"./en/B4.jpg": 7176,
	"./en/B5.jpg": 9541,
	"./en/B6.jpg": 6938,
	"./en/B7.jpg": 7751,
	"./en/B8.jpg": 36,
	"./en/C1.jpg": 2494,
	"./en/C2.jpg": 7513,
	"./en/C3.jpg": 3164,
	"./en/C4.jpg": 7575,
	"./en/C5.jpg": 5418,
	"./en/C6.jpg": 5909,
	"./en/C7.jpg": 4728,
	"./en/C8.jpg": 8227,
	"./en/D1.jpg": 3303,
	"./en/D2.jpg": 4632,
	"./en/D3.jpg": 8597,
	"./en/D4.jpg": 9358,
	"./en/D5.jpg": 9515,
	"./en/D6.jpg": 3068,
	"./en/D7.jpg": 857,
	"./en/D8.jpg": 8146,
	"./en/E1.jpg": 6404,
	"./en/E2.jpg": 6115,
	"./en/E3.jpg": 6006,
	"./en/E4.jpg": 2205,
	"./en/E5.jpg": 7312,
	"./en/E6.jpg": 4687,
	"./en/E7.jpg": 2978,
	"./en/E8.jpg": 7465,
	"./en/cards_back.jpg": 6347,
	"./it/A1.jpg": 2846,
	"./it/A2.jpg": 5929,
	"./it/A3.jpg": 7884,
	"./it/A4.jpg": 9079,
	"./it/A5.jpg": 5242,
	"./it/A6.jpg": 7845,
	"./it/A7.jpg": 680,
	"./it/A8.jpg": 8819,
	"./it/B1.jpg": 2595,
	"./it/B2.jpg": 964,
	"./it/B3.jpg": 9009,
	"./it/B4.jpg": 7346,
	"./it/B5.jpg": 5279,
	"./it/B6.jpg": 1664,
	"./it/B7.jpg": 893,
	"./it/B8.jpg": 5998,
	"./it/C1.jpg": 3856,
	"./it/C2.jpg": 8191,
	"./it/C3.jpg": 5522,
	"./it/C4.jpg": 4753,
	"./it/C5.jpg": 1028,
	"./it/C6.jpg": 5507,
	"./it/C7.jpg": 6982,
	"./it/C8.jpg": 6837,
	"./it/D1.jpg": 3037,
	"./it/D2.jpg": 754,
	"./it/D3.jpg": 8815,
	"./it/D4.jpg": 8647,
	"./it/D5.jpg": 5361,
	"./it/D6.jpg": 7606,
	"./it/D7.jpg": 7091,
	"./it/D8.jpg": 2632,
	"./it/E1.jpg": 7010,
	"./it/E2.jpg": 557,
	"./it/E3.jpg": 1328,
	"./it/E4.jpg": 2259,
	"./it/E5.jpg": 9094,
	"./it/E6.jpg": 8673,
	"./it/E7.jpg": 628,
	"./it/E8.jpg": 8343,
	"./it/cards_back.jpg": 6309
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9431;